import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

export type DeleteConfirmationDialogProps = {
  title: string;
  modaltext?: string;
  value: string;
  open: boolean;
  onClose: (value?: any) => void;
  confirmButtonText?: string;
  confirmButtonColor?: 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';
};

export const DeleteConfirmationDialog = (props: DeleteConfirmationDialogProps) => {
  const { t } = useTranslation(['common']);
  const {
    title,
    modaltext,
    onClose,
    value: valueProp,
    open,
    confirmButtonText = t('common:button.ok'),
    confirmButtonColor = 'primary',
    ...other
  } = props;

  const dialogId = `confirmation-dialog-title-${Date.now().toString(36) + Math.random().toString(36).substring(2)}`;

  const handleCancel = () => {
    onClose();
  };

  const handleOk = () => {
    onClose({ id: valueProp });
  };

  return (
    <Dialog onBackdropClick={() => false} disableEscapeKeyDown maxWidth='xs' aria-labelledby={dialogId} open={open} {...other}>
      <DialogTitle id={dialogId}>{title}</DialogTitle>
      {modaltext && <DialogContent>{modaltext}</DialogContent>}
      <DialogActions>
        <Button autoFocus onClick={handleCancel} color='primary'>
          {t('common:button.cancel')}
        </Button>
        <Button onClick={handleOk} color={confirmButtonColor} variant='contained'>
          {confirmButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
